/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import * as size from '@constant/size';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import { actions as modalActions } from '@store/slice/modal-slice';
import { useNavigate } from 'react-router-dom';
import {
  createClassroomPath,
  createSpeakingPath,
  createClipPath,
  createHomePath,
  createHubPath,
  createStudioPath,
  createTestPath,
  createClozePath,
  createVocabularyBookPath,
  IYAGIGO_PATH,
} from '@constant/iyagigo/route-path';
import IconTextBlock from 'component/common/block/icon-text-block';
import TextBlock from 'component/common/block/text-block';
import Gap from '@component/common/gap';
import SideContainer from '@component/common/architecture/side-container';
import { v4 as uuid4 } from 'uuid';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import otterBookLogoImage from '@asset/image/otter-book-logo.webp';
import ImageTextBlock from 'component/common/block/image-text-block';
import {
  IG_BEGIN_MENUS,
  IG_ENGLISH_CLASSROOM_MENUS,
  IG_ENGLISH_CLIP_MENUS,
  IG_ENGLISH_TEST_MENUS,
  IG_ENGLISH_CLOZE_MENUS,
  IG_JAPANESE_CLASSROOM_MENUS,
  IG_JAPANESE_CLIP_MENUS,
  IG_JAPANESE_TEST_MENUS,
  IG_JAPANESE_CLOZE_MENUS,
  IG_VOCABULARY_BOOK_MENUS,
  IG_HUB_MENUS,
  IG_STUDIO_MENUS,
  IS_BETA_SERVICE,
} from '@constant/iyagigo/variable';
import { useMySubscriptionQuery } from '@hook/billing/useApi';
import { EApiSubscriptionStatus } from '@datatype/billing/api-type';
import ModalBackground from '@component/common/modal/modal-background';
import { IIyagigoMenu, TIyagigoMainMenu, TIyagigoSubMenu } from '@datatype/iyagigo/type';
import IconBlock from '@component/common/block/icon-block';
import BoxBlock from '@component/common/block/box-block';
import { IS_PROBLEM_SERVICE } from '@constant/variable';
import { EApiLanguageCode } from '@datatype/iyagigo/api-type';

// ###################################
// 비회원/무료회원/유료회원
// [오늘의 영어ㆍ일본어]
// 비회원: 어휘10개 문법2 복습X
// 무료회원: 어휘20 문법5 복습O (결제개발 전까지, 유료회원정책 사용)
// 유료회원: 어휘100 문법20 복습O
// [시험]
// 비회원: RC2(짧/긴)문제/LC2문제 / 언어지식(짧1,긴1)  청해(짧1,긴1)
// 무료회원: RC(짧2/긴2) LC(짧2/긴2) / 언어지식(짧2,긴2)  청해(짧2,긴2)
// 유료회원: RC(짧5/긴5) LC(짧5/긴5) / 언어지식(짧5,긴5)  청해(짧5,긴5)
// 시험문제도 카드형식으로 바꾸기... (하루만 빵꾸나도... 문제수도 더 적게 만들어도됌)
// ###################################

// ###################################
{
  /*<main menu끼리는 최대한 격리시키기>*/
}
// [오늘의 영어ㆍ일본어] (오늘의 일본어를 카톡으로 판매하기...?)
// - 단어 (빈칸채우기, 난이도 조절, 20개)
// - 한자 (빈칸채우기, 난이도 조절, 20개) -> 일본만
// - 문법 (문장만들기, 난이도 조절, 5개)
// - 듣기 (문장만들기, 난이도 조절, 10개)
// - 생생표현 (드라마, 라디오,영화에서 가져오기, MVPx)
// - 일상(?)표현 (여행, 인사, 전화, MVPx)
// - 회화 (표현보다 자유로운?, MVPx)
// [시험]
// 일본어 시험  | 영어 시험
// - JLPT1   | TOEIC950
// - JLPT2ㆍ3 | TOEIC850ㆍ750
// - JLPT4ㆍ5 | TOEIC650ㆍ550
// - 회독
// - 오답노트
// - 즐겨찾기
// [학습관리]
// - 통계 (복잡하지않게... 복잡해봤짜 안봄. 그냥 내가 어느정도했다. 출석부, 일자별 어휘,문법 학습량, 학습시간 )
// - 학습설정
// - 학습노트
// - 나의등급
// - 단어장
// [설정]
// - 계정관리
// * - 고객지원
// - 의견 보내기
// - 도움말
// - 앱설정 (MVPx)
// - 결제
// + 랜딩페이지
// [선생님 찾기]?
// - 일기 (한국어 -> 50%는 채워준 일기 -> 채우기)
// [일본어 기초]
// - 문법
//   - 명사
//   - 동사 ...
// 학습노트
// - 기록
// - 단어장
// - 퀴즈
// 설정
// ###################################

// [일본어교실]
// - 생생표현
// - 기초문법
// - 히라가나
//
// [매일학습]
// - 어휘연습
// - 문법연습
// - 듣기연습
//
// [학습관리]
// - 학습통계
// - 학습설정

// TODO: 모바일 사이드탭에는 공통되는것만 남기기

const MainMenuContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const SubMenuContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const ServiceMenuContainer = styled(MainMenuContainer)``;

const SettingMenuContainer = styled(MainMenuContainer)`
  // position: absolute;
  // bottom: ${size.MARGIN_5};
`;

const LOGO_DESIGN = {
  box: {
    gap: size.MARGIN_1,
    width: '100%',
    alignX: 'left',
    margin: `${size.MARGIN_2} 0px ${size.MARGIN_2} 0px`,
    padding: `0px 0px 0px ${size.MARGIN_2}`,
    event: { cursor: 'pointer' },
  },
  image: { height: '70px' },
  text: { size: 'large', color: color.WHITE_1, bold: true },
} as const;

const MOBILE_MAIN_MENU_DESIGN = {
  text: { size: 'medium', color: color.WHITE_1 },
  icon: { size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  box: {
    gap: '10px',
    width: '100%',
    height: '35px',
    alignX: 'left',
    padding: `0 0 0 ${size.MARGIN_2}`,
  },
} as const;

const BETA_TEXT = 'Beta';

const BETA_LOGO_DESIGN = {
  text: { color: color.WHITE_1, size: 'medium' },
  box: {
    backgroundColor: color.YELLOW_1,
    borderRadius: size.BORDER_RADIUS_1,
    top: '10px',
    right: '10px',
    width: '40px',
    height: '20px',
  },
} as const;

const SideTab: React.FC<any> = () => {
  // ############### route ###############
  const navigate = useNavigate();

  // ############### state ###############
  const dispatch = useTypedDispatch();
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;
  const subscriptionQuery = useMySubscriptionQuery();
  const isSubscriber = subscriptionQuery.data?.data?.status === EApiSubscriptionStatus.ACTIVE;
  const currentStudyLanguage =
    useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;
  const clickedMainMenu = useTypedSelector((state) => state.rootReducer?.navigationReducer?.iyagigo?.mainMenu) ?? null;
  const clickedSubMenu = useTypedSelector((state) => state.rootReducer?.navigationReducer?.iyagigo?.subMenu) || null;
  const isMobileSideTab = useTypedSelector((state) => state.rootReducer?.navigationReducer?.isMobileSideTab) ?? false;
  const isWorkbookStudying = useTypedSelector((state) => state.rootReducer?.workbookReducer?.isStudying) ?? false;
  const isClassroomStudying = useTypedSelector((state) => state.rootReducer?.classroomReducer?.isStudying) ?? false;
  const isStudying = isWorkbookStudying || isClassroomStudying;
  // ############### api ###############

  // ############### handler ###############
  const handleLogoClick = () => {
    if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    navigate(IYAGIGO_PATH.INITIAL_SERVICE_PATH);
  };
  const handleMobileModalClick = () => dispatch(navigationActions.closeMobileSideTab());

  // ############### main menu를 클릭 -> routing ###############
  const handleMainMenuClick = (mainMenu: TIyagigoMainMenu) => {
    switch (mainMenu) {
      case 'begin':
        dispatch(navigationActions.storeIyagigoMainMenu('begin'));
        // navigate(IYAGIGO_PATH.SETTING_PATH);
        break;
      case 'home':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'home' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('home'));
          navigate(createHomePath());
        }
        break;
      case 'classroom':
        if (isStudying) {
          dispatch(
            modalActions.showDialogModal({
              type: 'workbook-quit',
              data: { mainMenu: 'classroom' },
            }),
          );
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('classroom'));
          navigate(createClassroomPath('home'));
        }
        break;
      case 'clip':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'clip' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('clip'));
          navigate(createClipPath('home'));
        }
        break;
      case 'speaking':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'speaking' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('speaking'));
          navigate(createSpeakingPath());
        }
        break;
      case 'cloze':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'cloze' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('cloze'));
          navigate(createClozePath('home'));
        }
        break;
      case 'test':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'test' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('test'));
          navigate(createTestPath('home'));
        }
        break;
      case 'hub':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'hub' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('hub'));
          navigate(createHubPath('home'));
        }
        break;
      case 'studio':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'studio' } }));
        } else {
          if (!isAuthenticated) {
            dispatch(modalActions.showWallToast({ type: 'signup-wall', data: { trigger: 'access' } }));
            return;
          }

          dispatch(navigationActions.storeIyagigoMainMenu('studio'));
          navigate(createStudioPath('home'));
        }
        break;
      case 'vocabulary-book':
        if (isStudying) {
          dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'vocabulary-book' } }));
        } else {
          dispatch(navigationActions.storeIyagigoMainMenu('vocabulary-book'));
          navigate(createVocabularyBookPath('home'));
        }
        break;
      default:
    }
  };

  // ############### main menu 요소를 만드는 함수 (UI, Event etc...) ###############
  const createMainMenuDesign = (mainMenu: TIyagigoMainMenu, clickedMainMenu, device: 'web' | 'mobile') => {
    const isClicked = clickedMainMenu === mainMenu;

    return {
      text: { size: 'medium', color: color.WHITE_1 },
      icon: { size: 'medium', kind: 'outlined', color: color.WHITE_1 },
      box: {
        gap: '10px',
        width: '100%',
        height: '35px',
        alignX: 'left',
        padding: `0 0 0 ${size.MARGIN_2}`,
        backgroundColor: isClicked ? color.BLACK_1 : 'transparent',
        event: {
          cursor: 'pointer',
          hover: `
            background-color: ${color.BLACK_1};
            border: none;
          `,
        },
      },
    } as const;
  };

  // ############### sub menu 요소를 만드는 함수 (Routing, UI, Event etc...) ###############
  const createSubMenuItem = (item: any, device: 'web' | 'mobile') => {
    const { type, menu, text, icon }: { type: TIyagigoMainMenu; menu: any; text: any; icon: any } = item;

    const handleBeginClick = (beginMenu: TIyagigoSubMenu['begin']) => {
      // dispatch(navigationActions.storeIyagigoSubMenu(beginMenu));
      // navigate(IYAGIGO_PATH.SETTING_PATH);
      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleClassroomClick = (classroomMenu: TIyagigoSubMenu['classroom']) => {
      const mainMenu = 'classroom';

      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: classroomMenu },
          }),
        );
      } else {
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: classroomMenu }));
      }

      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleClipClick = (clipMenu: TIyagigoSubMenu['clip']) => {
      const mainMenu = 'clip';

      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: clipMenu },
          }),
        );
      } else {
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: clipMenu }));
      }

      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleVocabularyBookClick = (vocabularyBookMenu: TIyagigoSubMenu['vocabulary-book']) => {
      const mainMenu = 'vocabulary-book';

      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: vocabularyBookMenu },
          }),
        );
      } else {
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: vocabularyBookMenu }));
      }

      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleClozeClick = (clozeMenu: TIyagigoSubMenu['cloze']) => {
      const mainMenu = 'cloze';

      if (isStudying) {
        // TODO: SAGA? 리팩토링 가능?
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: clozeMenu },
          }),
        );
      } else {
        // page flow: sub menu click -> main menu page
        // dispatch(navigationActions.storeIyagigoMainMenu(mainMenu));
        // navigate(createClozePath('study'));
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: clozeMenu }));
      }
      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleTestClick = (testMenu: TIyagigoSubMenu['test']) => {
      const mainMenu = 'test';

      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: testMenu },
          }),
        );
      } else {
        // page flow: sub menu click -> main menu page
        // dispatch(navigationActions.storeIyagigoMainMenu(mainMenu));
        // navigate(createTestPath());
        // dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: testMenu }));
      }
      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleHubClick = (hubMenu: TIyagigoSubMenu['hub']) => {
      const mainMenu = 'hub';
      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: 'cloze', subMenu: hubMenu },
          }),
        );
      } else {
        // dispatch(navigationActions.storeIyagigoMainMenu(mainMenu));
        // page flow: sub menu click -> sub menu page
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: hubMenu }));
        navigate(createHubPath());
      }
      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleStudioClick = (studioMenu: TIyagigoSubMenu['studio']) => {
      const mainMenu = 'studio';

      if (isStudying) {
        dispatch(
          modalActions.showDialogModal({
            type: 'workbook-quit',
            data: { mainMenu: mainMenu, subMenu: studioMenu },
          }),
        );
      } else {
        if (studioMenu === 'statistic') {
          if (!isAuthenticated) {
            dispatch(modalActions.showWallToast({ type: 'signup-wall', data: { trigger: 'access' } }));
            return;
          }
        }
        if (studioMenu === 'configuration') {
          if (!isSubscriber) {
            dispatch(modalActions.showWallToast({ type: 'subscription-wall', data: { trigger: 'access' } }));
            return;
          }
        }
        // dispatch(navigationActions.storeIyagigoMainMenu(mainMenu));
        // page flow: sub menu click -> sub menu page
        dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: mainMenu, subMenu: studioMenu }));
        navigate(createStudioPath());
      }

      if (IS_IYAGIGO_MOBILE_VIEW) dispatch(navigationActions.closeMobileSideTab());
    };

    const handleSubMenuClick = () => {
      if (type === 'begin') {
        handleBeginClick(menu);
      } else if (type === 'cloze') {
        handleClozeClick(menu);
      } else if (type === 'test') {
        handleTestClick(menu);
      } else if (type === 'hub') {
        handleHubClick(menu);
      } else if (type === 'studio') {
        handleStudioClick(menu);
      } else if (type === 'classroom') {
        handleClassroomClick(menu);
      } else if (type === 'clip') {
        handleClipClick(menu);
      } else if (type === 'vocabulary-book') {
        handleVocabularyBookClick(menu);
      } else {
        throw new Error('invalid main menu');
      }
    };

    const createSubMenuDesign = (
      subMenu: IIyagigoMenu['sub'],
      clickedSubMenu: IIyagigoMenu['sub'],
      device: 'web' | 'mobile',
    ) => {
      const isClicked = clickedSubMenu === subMenu;
      // const isClicked = false;

      if (device === 'web') {
        return {
          text: {
            size: 'medium',
            ...(isClicked ? { color: color.WHITE_1, bold: true } : { color: color.GRAY_2 }),
            event: {
              cursor: 'pointer',
              hover: `
              border: none;
              color: ${color.WHITE_1};
            `,
            },
          },
          box: {
            width: '100%',
            height: '35px',
            alignX: 'left',
            padding: `0 0 0 ${size.MARGIN_4}`,
            event: { cursor: 'pointer' },
          },
        } as const;
      } else if (device === 'mobile') {
        return {
          icon: { size: 'medium', kind: 'outlined', color: color.WHITE_1 },
          text: { size: 'medium', color: color.WHITE_1 },
          box: {
            gap: '10px',
            width: '100%',
            height: '35px',
            alignX: 'left',
            padding: `0 0 0 ${size.MARGIN_4}`,
            backgroundColor: isClicked ? color.BLACK_1 : 'transparent',
          },
        } as const;
      } else {
        return {};
      }
    };

    return (
      <TextBlock
        key={uuid4()}
        text={text}
        design={createSubMenuDesign(menu, clickedSubMenu, device)}
        click={{ handler: handleSubMenuClick }}
      />
    );
  };

  // ############### variable ###############
  const WebJapaneseTodayMenus = IG_JAPANESE_CLOZE_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebEnglishTodayMenus = IG_ENGLISH_CLOZE_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebJapaneseTestMenus = IG_JAPANESE_TEST_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebEnglishTestMenus = IG_ENGLISH_TEST_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebStudioSubMenus = IG_STUDIO_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebJapaneseClassroomMenus = IG_JAPANESE_CLASSROOM_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebEnglishClassroomMenus = IG_ENGLISH_CLASSROOM_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebJapaneseClipMenus = IG_JAPANESE_CLIP_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebEnglishClipMenus = IG_ENGLISH_CLIP_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const WebVocabularyBookMenus = IG_VOCABULARY_BOOK_MENUS.map((item) => createSubMenuItem(item, 'web'));
  const hubMenus = isAuthenticated ? IG_HUB_MENUS : IG_HUB_MENUS.slice(1);
  const WebHubSubMenus = hubMenus.map((item) => createSubMenuItem(item, 'web'));
  const MobileHubSubMenus = hubMenus.map((item) => createSubMenuItem(item, 'mobile'));
  const MENU_GAP = size.MARGIN_1;

  // console.log('### NODE_ENV:', process.env.NODE_ENV, ' ###');

  let testText;
  let classroomText;
  let WebTodayMenus;
  let WebClassroomMenus;
  let WebClipMenus;
  let WebTestSubMenus;
  const isClassroomVisible =
    currentStudyLanguage === EApiLanguageCode.JAPANESE || currentStudyLanguage === EApiLanguageCode.ENGLISH;

  switch (currentStudyLanguage) {
    case EApiLanguageCode.ENGLISH:
      testText = '영어 시험';
      classroomText = '교실';
      WebTodayMenus = WebEnglishTodayMenus;
      WebClassroomMenus = WebEnglishClassroomMenus;
      WebClipMenus = WebEnglishClipMenus;
      WebTestSubMenus = WebEnglishTestMenus;
      break;
    case EApiLanguageCode.JAPANESE:
      testText = '일본어 시험';
      classroomText = '교실';
      WebTodayMenus = WebJapaneseTodayMenus;
      WebClassroomMenus = WebJapaneseClassroomMenus;
      WebClipMenus = WebJapaneseClipMenus;
      WebTestSubMenus = WebJapaneseTestMenus;
      break;
    default:
      break;
  }

  return IS_IYAGIGO_MOBILE_VIEW && isMobileSideTab ? (
    <ModalBackground onClick={handleMobileModalClick}>
      <SideContainer
        design={{
          width: size.IYAGIGO_MOBILE_SIDE_WIDTH,
          backgroundColor: color.BLACK_2,
          top: '0px',
          align: 'up',
        }}>
        {IS_BETA_SERVICE && <TextBlock text={BETA_TEXT} design={BETA_LOGO_DESIGN} />}
        <ImageTextBlock
          src={otterBookLogoImage}
          alt='otterbrick'
          text='이야기고'
          design={LOGO_DESIGN}
          click={{ handler: handleLogoClick }}
        />
        <Gap height={size.MARGIN_2} />
        {/* 학습관리(studio)는 하단탭에서 제거 — 모바일 사이드탭으로 진입. 클릭 시 사이드탭 닫기 */}
        <IconTextBlock
          icon={'table-chart'}
          text={'학습관리'}
          design={MOBILE_MAIN_MENU_DESIGN}
          click={{
            handler: () => {
              handleMainMenuClick('studio');
              // 미인증/학습중이면 handleMainMenuClick이 wall/quit 모달을 띄우고 이동하지 않으므로 사이드탭 유지
              if (isAuthenticated && !isStudying) dispatch(navigationActions.closeMobileSideTab());
            },
          }}
        />
        <Gap height={MENU_GAP} />
        <IconTextBlock icon={'setting'} text='설정' design={MOBILE_MAIN_MENU_DESIGN} />
        <SubMenuContainer>{MobileHubSubMenus}</SubMenuContainer>
      </SideContainer>
    </ModalBackground>
  ) : (
    <SideContainer
      design={{
        width: size.WEB_SIDE_WIDTH,
        backgroundColor: color.BLACK_2,
        top: '0px',
        align: 'up',
      }}>
      {IS_BETA_SERVICE && <TextBlock text={BETA_TEXT} design={BETA_LOGO_DESIGN} />}
      <ImageTextBlock
        src={otterBookLogoImage}
        alt='otterbrick'
        text='이야기고'
        design={LOGO_DESIGN}
        click={{ handler: handleLogoClick }}
      />
      <Gap height={size.MARGIN_2} />
      <ServiceMenuContainer>
        <IconTextBlock
          icon={'home'}
          text={'홈'}
          design={createMainMenuDesign('home', clickedMainMenu, 'web')}
          click={{ handler: () => handleMainMenuClick('home') }}
        />
        <Gap height={MENU_GAP} />
        {/* 영어 교실은 기본표현·생활회화를 노출 */}
        {isClassroomVisible && (
          <>
            <IconTextBlock
              icon={'edit-note'}
              text={classroomText}
              design={createMainMenuDesign('classroom', clickedMainMenu, 'web')}
              click={{ handler: () => handleMainMenuClick('classroom') }}
            />
            {clickedMainMenu === 'classroom' && <SubMenuContainer>{WebClassroomMenus}</SubMenuContainer>}
            <Gap height={MENU_GAP} />
          </>
        )}
        <>
          <BoxBlock
            design={{ box: createMainMenuDesign('speaking', clickedMainMenu, 'web').box }}
            onClick={() => handleMainMenuClick('speaking')}>
            <IconBlock icon='bot' design={{ icon: createMainMenuDesign('speaking', clickedMainMenu, 'web').icon }} />
            <TextBlock
              text='AI말하기'
              design={{ text: createMainMenuDesign('speaking', clickedMainMenu, 'web').text }}
            />
          </BoxBlock>
        </>
        {/* 기존 Clip 메뉴 보존
            <Gap height={MENU_GAP} />
            <IconTextBlock
              icon={'feed'}
              text={'표현'}
              design={createMainMenuDesign('clip', clickedMainMenu, 'web')}
              click={{ handler: () => handleMainMenuClick('clip') }}
            />
            {clickedMainMenu === 'clip' && <SubMenuContainer>{WebClipMenus}</SubMenuContainer>}
        */}
        <Gap height={MENU_GAP} />
        <IconTextBlock
          icon={'quiz'}
          text={'빈칸문제'}
          design={createMainMenuDesign('cloze', clickedMainMenu, 'web')}
          click={{ handler: () => handleMainMenuClick('cloze') }}
        />
        {clickedMainMenu === 'cloze' && <SubMenuContainer>{WebTodayMenus}</SubMenuContainer>}
        <Gap height={MENU_GAP} />
        <IconTextBlock
          icon={'book'}
          text={'단어집'}
          design={createMainMenuDesign('vocabulary-book', clickedMainMenu, 'web')}
          click={{ handler: () => handleMainMenuClick('vocabulary-book') }}
        />
        {clickedMainMenu === 'vocabulary-book' && <SubMenuContainer>{WebVocabularyBookMenus}</SubMenuContainer>}
        <Gap height={MENU_GAP} />
        {IS_PROBLEM_SERVICE && (
          <>
            <IconTextBlock
              icon={'edit-note'}
              text={testText}
              design={createMainMenuDesign('test', clickedMainMenu, 'web')}
              click={{ handler: () => handleMainMenuClick('test') }}
            />
            {clickedMainMenu === 'test' && <SubMenuContainer>{WebTestSubMenus}</SubMenuContainer>}
            <Gap height={MENU_GAP} />
          </>
        )}
        <IconTextBlock
          icon={'table-chart'}
          text={'학습관리'}
          design={createMainMenuDesign('studio', clickedMainMenu, 'web')}
          click={{ handler: () => handleMainMenuClick('studio') }}
        />
        {clickedMainMenu === 'studio' && <SubMenuContainer>{WebStudioSubMenus}</SubMenuContainer>}
      </ServiceMenuContainer>
      <Gap height={MENU_GAP} />
      <SettingMenuContainer>
        <IconTextBlock
          icon={'setting'}
          text='설정'
          design={createMainMenuDesign('hub', clickedMainMenu, 'web')}
          click={{ handler: () => handleMainMenuClick('hub') }}
        />
        {clickedMainMenu === 'hub' && <SubMenuContainer>{WebHubSubMenus}</SubMenuContainer>}
      </SettingMenuContainer>
    </SideContainer>
  );
};

export default SideTab;
